import * as http from '../http'
import { buildAggregatorUrl } from '.'

export const getErrors = async (fileId: number): Promise<string[]> => {
  var result = await http.get(buildAggregatorUrl(`Files/${fileId}/Errors`))
  return result
}
